import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';

const APK_URL = '/downloads/getscribedash.apk';

export default function AndroidDownloadBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isAndroid = /Android/i.test(window.navigator.userAgent);
    const isNativeApp = window.Capacitor?.isNativePlatform?.() === true;
    const isDismissed = window.sessionStorage.getItem('android-download-dismissed') === 'true';
    setVisible(isAndroid && !isNativeApp && !isDismissed);
  }, []);

  const dismiss = () => {
    window.sessionStorage.setItem('android-download-dismissed', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside
      className="fixed inset-x-3 bottom-20 z-[60] rounded-xl border border-blue-200 bg-white p-3 shadow-2xl sm:hidden"
      aria-label="Install GetScribeDash for Android"
      data-testid="android-download-banner"
    >
      <button
        type="button"
        onClick={dismiss}
        className="absolute right-2 top-2 rounded p-1 text-gray-500 hover:bg-gray-100"
        aria-label="Dismiss Android app download"
      >
        <X size={16} />
      </button>
      <div className="pr-7">
        <strong className="block text-sm text-gray-900">Get the Android app</strong>
        <span className="text-xs text-gray-600">Install GetScribeDash directly on your phone.</span>
      </div>
      <a
        href={APK_URL}
        download="getscribedash.apk"
        className="mt-3 flex w-full items-center justify-center gap-2 rounded-lg bg-[var(--brand-primary)] px-4 py-2.5 text-sm font-semibold text-white"
      >
        <Download size={17} />
        Install Android App (.apk)
      </a>
    </aside>
  );
}
